import React from "react";
import { Label } from "@/components/form";
import { EmailField, PhoneField, TextField as Input } from "@/components/form/fields";

export interface ContactFieldsProps {
  values: {
    phoneNumber: string;
    email: string;
    website?: string;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPhoneChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors?: {
    phoneNumber?: string;
    email?: string;
    website?: string;
  };
  includeWebsite?: boolean;
  className?: string;
}

const ContactFieldSet: React.FC<ContactFieldsProps> = ({
  values,
  onChange,
  onPhoneChange,
  errors = {},
  includeWebsite = true,
  className = "",
}) => {
  const handlePhoneInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onPhoneChange) {
      onPhoneChange(e);
    } else {
      onChange(e);
    }
  };

  return (
    <div className={`grid grid-cols-1 gap-6 md:grid-cols-2 ${className}`}>
      <div>
        <Label htmlFor="phoneNumber" required>
          Phone Number
        </Label>
        <Input
          id="phoneNumber"
          name="phoneNumber"
          type="tel"
          placeholder="(123) 456-7890"
          value={values.phoneNumber}
          onChange={handlePhoneInput}
          error={!!errors.phoneNumber}
          hint={errors.phoneNumber}
          required
        />
      </div>

      <div>
        <EmailField
          id="email"
          name="email"
          label="Email Address"
          placeholder="location@example.com"
          value={values.email}
          onChange={onChange}
          error={errors.email}
          hint={errors.email}
          required
          checkDuplicates={true}
          enableRealTimeValidation={true}
          validationTrigger="onBlur"
          entityType="gym_location"
        />
      </div>

      {includeWebsite && (
        <div className="md:col-span-2">
          <Label htmlFor="website">Website</Label>
          <Input
            id="website"
            name="website"
            type="url"
            placeholder="https://www.example.com"
            value={values.website || ""}
            onChange={onChange}
            error={!!errors.website}
            hint={errors.website}
          />
        </div>
      )}
    </div>
  );
};

export default ContactFieldSet; 